import { SLICE_NAME } from "../../model/types/types";

export const ActionType = {
  RETRIEVE_MANY_INVOICES: `${SLICE_NAME}/retrieve_many_invoices`,
} as const;
